import { render, staticRenderFns } from "./personalAuthComplete.vue?vue&type=template&id=2c112972&scoped=true"
import script from "./personalAuthComplete.vue?vue&type=script&lang=js"
export * from "./personalAuthComplete.vue?vue&type=script&lang=js"
import style0 from "./personalAuthComplete.vue?vue&type=style&index=0&id=2c112972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c112972",
  null
  
)

export default component.exports